import { Expose, Transform, Type } from 'class-transformer';
import { BaseEntity } from '@core/entities/_extra/base.entity';
import { GroupEntity, UserEntity } from '@core/entities';
import { ApprovedStatus, SubtaskStatus, TaskProgressStatus, TaskStatus } from '@core/enums';
import { SafeUrl } from '@angular/platform-browser';
import { DateTimeUtility } from '@core/utils';

export class TaskEntity extends BaseEntity<TaskEntity> {
  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  title = '';

  @Expose({ name: 'organizer_id' })
  organizerId = 0;

  @Expose({ name: 'task_tags' })
  tags: string[] | TaskTagEntity[] = [];

  date = DateTimeUtility.getDateOnly(new Date().toISOString());

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  description = '';

  @Expose({ name: 'group_id' })
  groupId = 0;

  @Expose({ name: 'event_id' })
  eventId? = 0;

  @Expose({ name: 'course_id' })
  courseId = 0;

  status: TaskStatus | ApprovedStatus | SubtaskStatus | TaskProgressStatus = TaskStatus.ToDo;

  @Expose({ name: 'userstask' })
  @Type(() => UserEntity)
  user: UserEntity;

  @Type(() => SubTaskEntity)
  subtasks: SubTaskEntity[] = [];

  subtaskCompletedCount: number;
  subtaskCount: number;
  taskType: string;
  collaborators: TaskCollaborator[] = [];
  image: SafeUrl | string;

  // for front-end ui only
  imageUrl: SafeUrl = '';

  // For updated record
  file = '';

  // For Only Frontend
  @Expose({ name: 'userstask' })
  usersTask: Partial<UserEntity>;

  // For Task List to segregate tasks by assigned user
  @Expose({ name: 'collaborator' })
  @Type(() => TaskCollaborators)
  taskCollaborators: TaskCollaborators[] = [];

  @Expose()
  @Type(() => GroupEntity)
  group: Pick<GroupEntity, 'id' | 'name' | 'description'>;

  constructor(values?: Partial<TaskEntity>) {
    super(values);
    this.initEntity(values);
  }
}

export class SubTaskEntity {
  id: number;
  @Expose({ name: 'task_id' })
  taskId = 0;

  title = '';
  description = '';

  @Expose({ name: 'assigned_to' })
  assignedTo: SubTaskAssignedTo[] = [];

  @Transform((item) => item.value.toString() || '0')
  status: string | number = '0';

  @Transform((item) => DateTimeUtility.getDateOnly(item.value))
  date = DateTimeUtility.getDateOnly(new Date().toISOString());

  // UI Only
  isArrowUp = false;
}

export class TaskCollaborator {
  @Expose({ name: 'user_id' })
  userId = 0;
  @Expose({ name: 'approved_status' })
  approvedStatus: ApprovedStatus = ApprovedStatus.Approved;
}

// This is specifically for the task collaborators for Task list api
export class TaskCollaborators {
  @Expose({ name: 'user_id' })
  userId: number;

  @Expose()
  @Transform(({ value }) => (Array.isArray(value) ? value[0] || null : value))
  @Type(() => UserEntity)
  user: UserEntity;
}

export class TaskTagEntity {
  id: number;

  @Expose({ name: 'tag_name' })
  tagName: string;

  @Expose({ name: 'tag_id' })
  tagId: number;

  @Expose({ name: 'task_id' })
  taskId: string;
}

export class SubTaskAssignedTo {
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'approved_status' })
  approvedStatus: number;
  memberId: number;
}
